// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"dashboard_dashboard__3MJQz","linhaFlex":"dashboard_linhaFlex__zlBnM"};